export default "__VITE_ASSET__C2x6Lv6Q__"